import React from 'react';
import { Outlet } from 'react-router';

import { ErrorBoundaryReset } from 'components/error/ErrorBoundary';
import { LayoutContainer } from 'components/templates/layouts/web/PastLayout';
import Navigation from 'components/templates/navigation/Navigation';

import Footer from '../../footer/Footer';
import { LayoutWrapper } from '../web/BaseLayout';

const MobilePastLayout = () => {
  return (
    <LayoutWrapper id="page-content-wrapper">
      <LayoutContainer>
        <div className="inavi_content">
          {/* 네비게이션 */}
          <Navigation />
          <ErrorBoundaryReset>
            <Outlet />
          </ErrorBoundaryReset>
        </div>
      </LayoutContainer>
      <Footer />
    </LayoutWrapper>
  );
};

export default MobilePastLayout;
